export default __webpack_public_path__ + "static/media/fast-time.cb5d7935.svg";